import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSubmitted(true);
        } catch (err) {
            // API always returns 200 to prevent enumeration; only network errors can land here
            toast.error("Erreur réseau, réessayez dans un instant.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <div className="max-w-md mx-auto px-6 py-16">
                <div className="sd-card p-8 fade-up">
                    <div className="overline mb-2">Mot de passe oublié</div>
                    <h1 className="font-display text-3xl mb-4">Pas de panique.</h1>
                    {submitted ? (
                        <div className="space-y-4" data-testid="forgot-success">
                            <div className="bg-[#F0FDF4] border-l-4 border-green-500 rounded-lg p-4 text-sm">
                                Si cette adresse correspond à un compte Renforteo,
                                vous allez recevoir dans quelques instants un e-mail
                                contenant un lien pour choisir un nouveau mot de passe.
                                Ce lien est valable <b>1 heure</b>.
                            </div>
                            <p className="text-xs text-slate-500">
                                Pensez à vérifier votre dossier « Courriers indésirables »
                                si l'e-mail ne s'affiche pas dans votre boîte de réception.
                            </p>
                            <Link
                                to="/connexion"
                                className="btn-ghost-navy w-full text-center block"
                                data-testid="forgot-back-login"
                            >
                                Retour à la connexion
                            </Link>
                        </div>
                    ) : (
                        <>
                            <p className="text-sm text-slate-600 mb-6">
                                Saisissez l'adresse e-mail associée à votre compte.
                                Nous vous enverrons un lien pour choisir un nouveau
                                mot de passe.
                            </p>
                            <form onSubmit={submit} className="space-y-4">
                                <div>
                                    <label className="block text-sm font-semibold mb-1">
                                        E-mail
                                    </label>
                                    <input
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="w-full px-4 py-3 rounded-xl border border-slate-200 focus-ring bg-white"
                                        data-testid="forgot-email-input"
                                    />
                                </div>
                                <button
                                    disabled={loading}
                                    className="btn-gold w-full"
                                    data-testid="forgot-submit-btn"
                                >
                                    {loading ? "Envoi..." : "M'envoyer le lien"}
                                </button>
                            </form>
                            <div className="text-sm text-slate-500 mt-6 text-center">
                                <Link
                                    to="/connexion"
                                    className="text-[#0B192C] font-semibold hover:text-[#F5A623]"
                                    data-testid="forgot-back-link"
                                >
                                    ← Retour à la connexion
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
}
